import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import BarbersList from '../BarbersList';
import ShopType from '../../../shops/components/shopType';

const UsersList = props => (
  <ReactTable
    className="c-table-new c-table-with-sticky-header c-no-hover"
    data={props.users}
    minRows={0}
    showPagination={false}
    resizable={false}
    expanded={props.expanded}
    defaultPageSize={20000}
    getTrProps={(state, row) => ({
      'data-automation-id': row.original.name,
      onClick: props.onExpand(row.viewIndex),
      className: 'u-cursor-pointer',
    })}
    columns={[
      {
        Header: 'Shop Name',
        accessor: user => user.name,
        id: 'name',
        className: 'u-text-center',
      },
      {
        Header: 'Shop type',
        accessor: user => user.kind,
        id: 'kind',
        className: 'u-text-center',
        Cell: row => <ShopType type={row.value} />,
      },
      {
        Header: 'Barbers',
        id: 'barberCount',
        accessor: user => user.barberCount,
      },
      {
        Header: 'Users count',
        id: 'userCount',
        accessor: user => user.userCount,
        className: 'u-text-center',
        width: 100,
      },
    ]}
    defaultSorted={[
      {
        id: 'name',
        asc: true,
      },
    ]}
    SubComponent={row => (
      <BarbersList key="expanded" shopId={row.original.id} />
    )}
  />
);

UsersList.propTypes = {
  users: PropTypes.array,
  onExpand: PropTypes.func.isRequired,
  expanded: PropTypes.array.isRequired,
};

UsersList.defaultProps = {
  users: [],
};

export default UsersList;
